<template>
  <div id="standing" v-if="table.length > 0">
    <table id="table" cellspacing="0" cellspadding="0">
      <tr class="headers">
        <th class="name" colspan="2">
          {{ $t("miclive.competition.scoreboard") }}
        </th>
        <th class="col"></th>
        <th class="col">{{ $t("miclive.competition.goal") }}</th>
      </tr>
      <tr
        class="item"
        v-for="(position, index) in table"
        :class="{ headers: position.type == 'groups' }"
      >
        <template
          v-if="
            !clubs[position.club_id] ||
              !clubs[position.club_id].teams[position.team_id]
          "
        >
          {{ clubs[position.club_id] }}</template
        >
        <template v-else>
          <td class="col pos">
            <span class="col pos">{{ position.position }}</span>
          </td>
          <td class="shield">
            <cld-image
              class="shield"
              :publicId="clubs[position.club_id].shield"
              type="fetch"
              loading="lazy"
            >
              <cld-transformation
                height="100"
                radius="3"
                crop="fill"
                fetchFormat="auto"
              />
            </cld-image>
          </td>
          <td class="name">
            <template v-if="position.name">
              <b>{{ position.name }} {{ position.surname }}</b>
            </template>
            {{ clubs[position.club_id].teams[position.team_id].name }}
          </td>
          <td class="col b">{{ position.goals }}</td></template
        >
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Ranking",
  props: {
    table: Array
  },
  data() {
    return {};
  },
  computed: {
    clubs() {
      return this.$store.getters["competition/getClubs"]();
    },
    teams() {
      return this.$store.getters["competition/getTeamsFollowing"];
    }
  },
  methods: {
    load() {}
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#standing {
  #table {
    width: 100%;
    // max-width: 1000px;

    margin: 0 auto;

    td {
      padding: 7px 5px;
      border-bottom: 2px solid #eee;
    }
    th {
      padding: 10px 5px;
      font-family: $font-title;
      font-size: 12px;
      text-align: left;
    }
    tr {
      background-color: #fff;
      border-radius: 4px;
      &.headers {
        background-color: unset;
      }
    }

    .item {
      .col {
        &.pos {
          color: $main-color;
          font-family: $font-title;
          width: 15px;
          padding: 0 5px;
        }

        &.shield {
          width: 30px;
          text-align: center;
          img {
            height: 30px;
          }
        }

        &.b {
          font-family: AvantGarde;
          padding: 0 10px;
        }
      }

      .shield {
        width: 30px;
        padding: 4px 0 2px 0;
        text-align: center;
      }

      .name {
        font-size: 12px;
        // font-family: $font-title;
        text-align: left;
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;

        b {
          display: block;
          font-family: AvantGarde;
        }
      }

      .team {
        .name {
          padding-top: 20px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
}

// @media only screen and (max-width: 600px) {
//   #standing {
//     #table {
//       tr {
//       }

//       td {
//         padding: 2px 4px;
//         font-size: 12px;
//       }

//       .headers {
//         th {
//           padding: 5px;
//           font-size: 12px;
//         }

//         .name {
//           font-size: 16px;
//         }
//       }

//       .item {
//         .col {
//           &.pos {
//           }

//           &.shield {
//             width: 40px;
//             text-align: center;

//             img {
//               height: 30px;
//             }
//           }

//           &.b {
//           }
//         }

//         .name {
//           width: 30%;
//         }

//         .team {
//           .name {
//             padding-top: 20px;
//           }
//         }
//       }
//     }
//   }
// }
</style>
